import styles from "./Kbd.module.css";

/**
 * A key as it is written on a keyboard — „Esc", „F", „Strg". Mono, small,
 * outlined: it reads as a key and not as a word. Hand it the key's name, one
 * `<Kbd>` per key.
 */
export function Kbd({ children }: { children: string }) {
  return <kbd className={styles.kbd}>{children}</kbd>;
}
